(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Function to check if there are active filters
  function hasActiveFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    return Array.from(urlParams.keys()).some(key => key.startsWith('filter.'));
  }

  // Function to check if filters are manually hidden
  function areFiltersManuallyHidden() {
    const resultsList = document.querySelector('results-list');
    return resultsList?.dataset.filtersManuallyHidden === 'true';
  }

  // Function to set manually hidden state
  function setFiltersManuallyHidden(hidden) {
    const resultsList = document.querySelector('results-list');
    if (resultsList) {
      if (hidden) {
        resultsList.dataset.filtersManuallyHidden = 'true';
      } else {
        delete resultsList.dataset.filtersManuallyHidden;
      }
    }
  }

  // Function to check and show filters (open by default on desktop unless manually hidden)
  function checkAndShowFilters() {
    const resultsList = document.querySelector('results-list');
    if (!resultsList) return;
    
    // Only show filters on desktop (screen width >= 1024px)
    const isDesktop = window.innerWidth >= 1024;
    
    // On desktop: keep filters closed by default (was auto-open unless manually hidden)
    if (isDesktop && !areFiltersManuallyHidden()) {
      // resultsList.classList.add('filters-visible');
    } else if (!isDesktop) {
      // Remove filters-visible class on mobile
      resultsList.classList.remove('filters-visible');
    } else {
      // Desktop but manually hidden - remove the class
      resultsList.classList.remove('filters-visible');
    }
  }

  // Update products count with pagination info
  function updateProductsCount() {
    const productsCountWrapper = document.querySelector('.collection-results-count-wrapper[data-total-products]');
    if (!productsCountWrapper) return;

    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;

    const totalProducts = parseInt(productsCountWrapper.dataset.totalProducts) || 0;
    const productItems = productGrid.querySelectorAll('.product-grid__item');
    const currentCount = productItems.length;

    if (currentCount === 0) return;

    // Get page number from URL or from first product item
    const urlParams = new URLSearchParams(window.location.search);
    let currentPage = parseInt(urlParams.get('page')) || 1;
    
    // Try to get page from product items
    const firstProduct = productItems[0];
    if (firstProduct && firstProduct.dataset.page) {
      currentPage = parseInt(firstProduct.dataset.page) || 1;
    }
    
    // Default page size is 24
    const pageSize = 24;
    
    // Calculate range
    const startNumber = (currentPage - 1) * pageSize + 1;
    let endNumber = currentPage * pageSize;
    
    // Cap at total products
    if (endNumber > totalProducts) {
      endNumber = totalProducts;
    }
    
    // If we have fewer items than expected, adjust
    if (currentCount < endNumber - startNumber + 1) {
      endNumber = startNumber + currentCount - 1;
    }

    const countText = productsCountWrapper.querySelector('.collection-results-count-text');
    if (countText) {
      countText.textContent = `Showing ${startNumber}-${endNumber} of ${totalProducts} products`;
    }
  }

  // Toggle filters visibility
  document.addEventListener('DOMContentLoaded', () => {
    // Update products count on load
    updateProductsCount();
    
    // Update on filter changes
    document.addEventListener('filter:update', () => {
      setTimeout(updateProductsCount, 100);
    });
    
    // Handle sort option selection - update styling immediately
    const sortOptions = document.querySelectorAll('.mobile-sort-modal__option');
    sortOptions.forEach(option => {
      const radio = option.querySelector('.mobile-sort-modal__radio');
      const text = option.querySelector('.mobile-sort-modal__option-text');
      
      if (radio && text) {
        // Handle click on the label
        option.addEventListener('click', (e) => {
          // Don't prevent default if clicking directly on the radio
          if (e.target === radio) return;
          
          // Uncheck all radios
          document.querySelectorAll('.mobile-sort-modal__radio').forEach(r => {
            r.checked = false;
          });
          
          // Remove selected class from all options
          document.querySelectorAll('.mobile-sort-modal__option-text').forEach(t => {
            t.classList.remove('mobile-sort-modal__option-text--selected');
          });
          
          // Check the clicked radio
          radio.checked = true;
          text.classList.add('mobile-sort-modal__option-text--selected');
        });
        
        // Handle radio change event
        radio.addEventListener('change', () => {
          if (radio.checked) {
            // Remove selected class from all options
            document.querySelectorAll('.mobile-sort-modal__option-text').forEach(t => {
              t.classList.remove('mobile-sort-modal__option-text--selected');
            });
            // Add selected class to this option
            text.classList.add('mobile-sort-modal__option-text--selected');
          }
        });
      }
    });
    
    // Handle mobile sort modal Apply button
    const mobileSortApply = document.getElementById('mobile-sort-apply');
    if (mobileSortApply) {
      mobileSortApply.addEventListener('click', () => {
        const form = document.getElementById('mobile-sort-form');
        if (form) {
          form.submit();
        }
      });
    }
    
    // Handle mobile sort modal Reset button
    const mobileSortReset = document.getElementById('mobile-sort-reset');
    if (mobileSortReset) {
      mobileSortReset.addEventListener('click', () => {
        const form = document.getElementById('mobile-sort-form');
        if (form) {
          // Build URL with current filters but without sort_by
          const url = new URL(form.action);
          const currentParams = new URLSearchParams(window.location.search);
          
          // Remove sort_by but keep all filter parameters
          currentParams.delete('sort_by');
          
          // Update URL with preserved filters
          const newUrl = new URL(form.action);
          newUrl.search = currentParams.toString();
          window.location.href = newUrl.toString();
        }
      });
    }
    
    // Update sort value display when sort changes
    const updateSortDisplay = () => {
      const sortValueDisplay = document.querySelector('[data-sort-value]');
      if (!sortValueDisplay) return;
      
      const urlParams = new URLSearchParams(window.location.search);
      const currentSort = urlParams.get('sort_by') || '';
      
      // Find the current sort name from the sorting component
      const sortingComponent = document.querySelector('sorting-filter-component');
      if (sortingComponent) {
        const statusValue = sortingComponent.querySelector('.sorting-status-value');
        if (statusValue) {
          sortValueDisplay.textContent = statusValue.textContent.trim();
        }
      }
    };
    
    // Update sort display on load and when filters update
    updateSortDisplay();
    document.addEventListener('filter:update', () => {
      setTimeout(updateSortDisplay, 100);
    });
    
    // Update filter count display
    const updateFilterDisplay = () => {
      const filterButton = document.getElementById('mobile-filter-button');
      if (!filterButton) return;
      
      const filterValueDisplay = filterButton.querySelector('.collection-mobile-sticky-bar__value');
      if (!filterValueDisplay) return;
      
      const urlParams = new URLSearchParams(window.location.search);
      const activeFilterCount = Array.from(urlParams.keys()).filter(key => key.startsWith('filter.')).length;
      
      if (activeFilterCount > 0) {
        // Count actual active filter values
        let totalActiveValues = 0;
        urlParams.forEach((value, key) => {
          if (key.startsWith('filter.')) {
            // Count comma-separated values
            const values = value.split(',').filter(v => v.trim() !== '');
            totalActiveValues += values.length;
          }
        });
        filterValueDisplay.textContent = totalActiveValues > 0 ? `${totalActiveValues} Applied` : 'No Filter Applied';
      } else {
        filterValueDisplay.textContent = 'No Filter Applied';
      }
    };
    
    // Update filter display on load and when filters update
    updateFilterDisplay();
    document.addEventListener('filter:update', () => {
      setTimeout(updateFilterDisplay, 100);
    });
    
    // Handle active state for sticky bar buttons when modals open
    const mobileSortModal = document.getElementById('mobile-sort-modal');
    const sortButton = document.getElementById('mobile-sort-button');
    if (mobileSortModal && sortButton) {
      mobileSortModal.addEventListener('dialog:open', () => {
        sortButton.classList.add('collection-mobile-sticky-bar__button--active');
      });
      mobileSortModal.addEventListener('dialog:close', () => {
        sortButton.classList.remove('collection-mobile-sticky-bar__button--active');
      });
    }
    
    // Handle switching between sort and filter modals from sticky bars
    const sortModalFilterButton = document.getElementById('mobile-sort-modal-filter-button');
    const filtersDrawer = document.getElementById('filters-drawer');
    const filtersDrawerSortButton = document.getElementById('filters-drawer-sort-button');
    
    if (sortModalFilterButton && filtersDrawer) {
      sortModalFilterButton.addEventListener('click', () => {
        if (mobileSortModal) {
          mobileSortModal.querySelector('dialog')?.close();
        }
        filtersDrawer.querySelector('dialog')?.showModal();
      });
    }
    
    if (filtersDrawerSortButton && mobileSortModal) {
      filtersDrawerSortButton.addEventListener('click', () => {
        if (filtersDrawer) {
          filtersDrawer.querySelector('dialog')?.close();
        }
        mobileSortModal.querySelector('dialog')?.showModal();
      });
    }
    
    const resultsList = document.querySelector('results-list');
    
    if (resultsList) {
      // Check if there are active filters on page load
      checkAndShowFilters();
      
      // Use event delegation on document - only handle clicks on our specific buttons
      // This ensures filter clicks work normally since we're not attached to resultsList
      document.addEventListener('click', (event) => {
        // Only handle clicks on our specific buttons
        const filtersButton = event.target.closest('#collection-filters-toggle');
        const closeButton = event.target.closest('#collection-filters-close');
        
        if (filtersButton) {
          event.preventDefault();
          event.stopPropagation();
          const isVisible = resultsList.classList.contains('filters-visible');
          resultsList.classList.toggle('filters-visible');
          
          // Track manual hide state
          if (isVisible) {
            // User is hiding the filters
            setFiltersManuallyHidden(true);
          } else {
            // User is showing the filters
            setFiltersManuallyHidden(false);
          }
          return;
        }
        
        if (closeButton) {
          event.preventDefault();
          event.stopPropagation();
          // Close the filters sidebar
          resultsList.classList.remove('filters-visible');
          setFiltersManuallyHidden(true);
          return;
        }
        
        // For all other clicks (including filter inputs), do nothing - let them work normally
      });

      // Use MutationObserver to preserve filters-visible class during morph
      // Restore filters on desktop by default unless manually hidden
      let isRestoring = false;
      const observer = new MutationObserver((mutations) => {
        if (isRestoring) return;
        
        const isDesktop = window.innerWidth >= 1024;
        
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target === resultsList && !areFiltersManuallyHidden() && isDesktop) {
              // If filters-visible was removed but filters haven't been manually hidden, restore it (desktop only)
              if (!target.classList.contains('filters-visible')) {
                isRestoring = true;
                // Use requestAnimationFrame to avoid conflicts with morph
                requestAnimationFrame(() => {
                  // Disabled auto-restore to keep filters closed by default
                  // if (!areFiltersManuallyHidden() && window.innerWidth >= 1024 && !target.classList.contains('filters-visible')) {
                  //   target.classList.add('filters-visible');
                  // }
                  isRestoring = false;
                });
              }
            } else if (target === resultsList && !isDesktop) {
              // Remove filters-visible class on mobile
              if (target.classList.contains('filters-visible')) {
                target.classList.remove('filters-visible');
              }
            }
          }
        });
      });

      // Observe class changes on results-list
      observer.observe(resultsList, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  });
  
  // Listen for filter updates to keep filters visible after applying
  document.addEventListener('filter:update', () => {
    // When new filters are applied, reset the manually hidden state and show filters
    setFiltersManuallyHidden(false);
    
    // Mark that we should keep filters visible immediately (desktop only)
    const resultsList = document.querySelector('results-list');
    const isDesktop = window.innerWidth >= 1024;
    if (resultsList && isDesktop) {
      // Keep filters closed by default on desktop
      // resultsList.classList.add('filters-visible');
    } else if (resultsList && !isDesktop) {
      // Remove filters-visible class on mobile
      resultsList.classList.remove('filters-visible');
    }
    
    // Check after view transition completes (if using view transitions)
    if (document.startViewTransition) {
      // View transition is async, check after it completes
      setTimeout(() => {
        checkAndShowFilters();
      }, 100);
    }
    
    // Also check after morph completes - use requestAnimationFrame chain
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        checkAndShowFilters();
      });
    });
    
    // Final check after a longer delay to catch any late morphs
    setTimeout(() => {
      checkAndShowFilters();
    }, 400);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  function hasActiveFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    return Array.from(urlParams.keys()).some((key) => key.startsWith('filter.'));
  }

  function areFiltersManuallyHidden() {
    const resultsList = document.querySelector('results-list');
    return resultsList?.dataset.filtersManuallyHidden === 'true';
  }

  function setFiltersManuallyHidden(hidden) {
    const resultsList = document.querySelector('results-list');
    if (!resultsList) return;

    if (hidden) {
      resultsList.dataset.filtersManuallyHidden = 'true';
    } else {
      delete resultsList.dataset.filtersManuallyHidden;
    }
  }

  function checkAndShowFilters() {
    const resultsList = document.querySelector('results-list');
    if (!resultsList) return;

    const isDesktop = window.innerWidth >= 1024;
    if (isDesktop && !areFiltersManuallyHidden()) {
      resultsList.classList.add('filters-visible');
    } else {
      resultsList.classList.remove('filters-visible');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sortOptions = document.querySelectorAll('.mobile-sort-modal__option');
    sortOptions.forEach((option) => {
      const radio = option.querySelector('.mobile-sort-modal__radio');
      const text = option.querySelector('.mobile-sort-modal__option-text');
      if (!radio || !text) return;

      option.addEventListener('click', (event) => {
        if (event.target === radio) return;
        document.querySelectorAll('.mobile-sort-modal__radio').forEach((input) => {
          input.checked = false;
        });
        document.querySelectorAll('.mobile-sort-modal__option-text').forEach((node) => {
          node.classList.remove('mobile-sort-modal__option-text--selected');
        });
        radio.checked = true;
        text.classList.add('mobile-sort-modal__option-text--selected');
      });

      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        document.querySelectorAll('.mobile-sort-modal__option-text').forEach((node) => {
          node.classList.remove('mobile-sort-modal__option-text--selected');
        });
        text.classList.add('mobile-sort-modal__option-text--selected');
      });
    });

    const mobileSortApply = document.getElementById('mobile-sort-apply');
    if (mobileSortApply) {
      mobileSortApply.addEventListener('click', () => {
        const form = document.getElementById('mobile-sort-form');
        form?.submit();
      });
    }

    const mobileSortReset = document.getElementById('mobile-sort-reset');
    if (mobileSortReset) {
      mobileSortReset.addEventListener('click', () => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('sort_by');
        window.location.href = currentUrl.toString();
      });
    }

    const updateSortDisplay = () => {
      const sortValueDisplay = document.querySelector('[data-sort-value]');
      if (!sortValueDisplay) return;
      const selectedSort = document.querySelector('#mobile-sort-form .mobile-sort-modal__radio:checked');
      if (!selectedSort) return;
      const optionText = selectedSort.closest('.mobile-sort-modal__option')?.querySelector('.mobile-sort-modal__option-text');
      if (optionText) {
        sortValueDisplay.textContent = optionText.textContent.trim();
      }
    };

    const updateFilterDisplay = () => {
      const filterButton = document.getElementById('mobile-filter-button');
      if (!filterButton) return;
      const filterValueDisplay = filterButton.querySelector('.collection-mobile-sticky-bar__value');
      if (!filterValueDisplay) return;

      if (!hasActiveFilters()) {
        filterValueDisplay.textContent = 'No Filter Applied';
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      let totalActiveValues = 0;
      urlParams.forEach((value, key) => {
        if (!key.startsWith('filter.')) return;
        const values = value.split(',').filter((entry) => entry.trim() !== '');
        totalActiveValues += values.length;
      });
      filterValueDisplay.textContent = totalActiveValues > 0 ? `${totalActiveValues} Applied` : 'No Filter Applied';
    };

    updateSortDisplay();
    updateFilterDisplay();
    document.addEventListener('filter:update', () => {
      setTimeout(updateSortDisplay, 100);
      setTimeout(updateFilterDisplay, 100);
    });

    const mobileSortModal = document.getElementById('mobile-sort-modal');
    const sortButton = document.getElementById('mobile-sort-button');
    if (mobileSortModal && sortButton) {
      mobileSortModal.addEventListener('dialog:open', () => {
        sortButton.classList.add('collection-mobile-sticky-bar__button--active');
      });
      mobileSortModal.addEventListener('dialog:close', () => {
        sortButton.classList.remove('collection-mobile-sticky-bar__button--active');
      });
    }

    const resultsList = document.querySelector('results-list');
    if (!resultsList) return;

    checkAndShowFilters();

    document.addEventListener('click', (event) => {
      const filtersButton = event.target.closest('#collection-filters-toggle');
      const closeButton = event.target.closest('#collection-filters-close');

      if (filtersButton) {
        event.preventDefault();
        event.stopPropagation();
        const isVisible = resultsList.classList.contains('filters-visible');
        resultsList.classList.toggle('filters-visible');
        setFiltersManuallyHidden(isVisible);
        return;
      }

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        resultsList.classList.remove('filters-visible');
        setFiltersManuallyHidden(true);
      }
    });

    let isRestoring = false;
    const observer = new MutationObserver((mutations) => {
      if (isRestoring) return;

      const isDesktop = window.innerWidth >= 1024;
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target === resultsList) {
          if (isDesktop && !areFiltersManuallyHidden() && !resultsList.classList.contains('filters-visible')) {
            isRestoring = true;
            requestAnimationFrame(() => {
              if (window.innerWidth >= 1024 && !areFiltersManuallyHidden()) {
                resultsList.classList.add('filters-visible');
              }
              isRestoring = false;
            });
          } else if (!isDesktop && resultsList.classList.contains('filters-visible')) {
            resultsList.classList.remove('filters-visible');
          }
        }
      }
    });

    observer.observe(resultsList, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  document.addEventListener('filter:update', () => {
    setFiltersManuallyHidden(false);
    checkAndShowFilters();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        checkAndShowFilters();
      });
    });
  });

  window.addEventListener('resize', checkAndShowFilters);

  } catch(e) { console.error(e); }
})();
})();
